import { AppointmentTimeFrames } from '@forwardflow/components/Campaign/AppointmentTimeFrame'

const AppointmentTimeFramesPage = () => {
   return (
      <>
         <AppointmentTimeFrames />
      </>
   )
}
export default AppointmentTimeFramesPage
